import { z } from 'zod'

import type { ZodInfer } from './utility-types.ts'

export const AttributesSchema = z.record(z.string(), z.any())

export const MarkTypeSchema = z.object({
  attrs: AttributesSchema.optional(),
  type: z.string(),
  text: z.string().optional(),
})

export const NodeTypeSchema = z.object({
  type: z.string(),
  attrs: AttributesSchema.optional(),
  content: z.array(z.record(z.string(), z.any())).optional(),
  marks: z.array(MarkTypeSchema).optional(),
  text: z.string().optional(),
})

export const FormattedTextNodeSchema = z.object({
  attrs: AttributesSchema.optional(),
  content: z.array(z.union([NodeTypeSchema, MarkTypeSchema])).optional(),
  type: z.string(),
  marks: z.array(MarkTypeSchema).optional(),
})

export const FormattedTextSchema = z.object({
  type: z.string(),
  content: z.array(FormattedTextNodeSchema),
})

export type FormattedText = ZodInfer<typeof FormattedTextSchema>
